import { GlobalState } from "little-state-machine";

export const updateIsMenuOpen = (
  state: GlobalState,
  isMenuOpen : boolean
) => ({
  ...state,
  isMenuOpen
});
